import { Injectable } from '@angular/core';
import { AppHttpClient } from '../api.interceptor';
import { environment } from '@env/environment';
import { HelpersService } from '@base/shared/services/helpers.service';

@Injectable()
export class UserRequests {
  private config = environment;

  constructor(
    private http: AppHttpClient,
    private helper: HelpersService
  ) {
  }

  /**
   * Return logged user profile
   */
  me() {
    const url = `${this.config.baseUrl}/v2/${this.config.services.users}/me`;
    return this.http.get(url);
  }

  /**
   * Submit password forgot
   * @param payload object with user email
   */
  forgotPassword(payload: any) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.users}/forgot_password`;
    return this.http.post(url, payload);
  }

  /**
   * Reset a new password
   * @param payload password data
   */
  resetPassword(payload: any) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.users}/password_reset`;
    return this.http.post(url, payload);
  }

  /**
   * Initial data validation before user sign up
   * @param payload user info
   */
  validateUserInfo(payload) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.users}/validate`;
    return this.http.post(url, payload);
  }

  /**
   * Account verify before user sign up
   * @param payload user info
   */
  accountVerify(payload) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.accounts}/verify`;
    return this.http.post(url, payload);
  }


  /**
   * Validate confirmation code
   * @param payload verification code
   */
  verifyCode(payload) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.users}/verify`;
    return this.http.post(url, payload);
  }

  /**
   * Get user information by code sent to email
   * @param payload email code info
   */
  getUserInfoBy(payload) {
    const query = this.helper.queryOptions(payload);
    const url = `${this.config.baseUrl}/v2/${this.config.services.users}/request${query}`;
    return this.http.get(url);
  }

  getContractInvitation(payload) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.users}/contract`;
    return this.http.get(url, payload);
  }

  /**
   * Request activation code
   * @param payload userId
   */
  resendActivationCode(payload) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.users}/resend_invitation`;
    return this.http.post(url, payload);
  }

  /**
   * Accept invitation from compan
   * @param payload user data
   */
  acceptInvitation(payload) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.users}/accept_request`;
    return this.http.post(url, payload);
  }

  /**
   * Searcj users by email
   * @param payload user data
   */
  searchUsers(contractId, payload) {
    const query = this.helper.queryOptions(payload);
    const url = `${this.config.baseUrl}/v2/${this.config.services.contracts}/${contractId}/users${query}`;
    return this.http.get(url);
  }

  /**
   * Send reset link
   * @param userId user id
   * @param payload email
   */
  sendResetLink(userId, payload) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.users}/${userId}/send_password_reset_link`;
    return this.http.post(url, payload);
  }

    /**
   * Send reset link
   * @param userId user id
   * @param payload email
   */
  sendResetPasswordAccountLink(contractId, userId) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.contracts}/${contractId}/${this.config.services.users}/${userId}/request_password_reset`;
    return this.http.put(url, {});
  }

  resendInvitation(contractId, userId) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.contracts}/${contractId}/${this.config.services.users}/${userId}/resend_invitation`;
    return this.http.post(url, {});
  }
}

